import { Routes, Route } from 'react-router-dom';
import ErrorBoundary from '@/components/ErrorBoundary';
import LandingPage from '@/pages/LandingPage';
import LoginPage from '@/pages/LoginPage';
import AuthVerifyPage from '@/pages/AuthVerifyPage';
import SettingsPage from '@/pages/SettingsPage';
import DashboardPage from '@/pages/DashboardPage';
import RevealPage from '@/pages/RevealPage';
import SyncPage from '@/pages/SyncPage';
import BookmarkletPage from '@/pages/BookmarkletPage';
import AdminPage from '@/pages/AdminPage';
import NotFoundPage from '@/pages/NotFoundPage';

function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/verify" element={<AuthVerifyPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        {/* Setup redirects to dashboard, which handles incomplete setup state */}
        <Route path="/setup" element={<DashboardPage />} />
        <Route path="/reveal/:token" element={<RevealPage />} />
        <Route path="/sync" element={<SyncPage />} />
        <Route path="/bookmarklet" element={<BookmarkletPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
